import * as types from './types';

const initialState = {
  userAccount: null,
  loading: false,
  fetched: false,
  success: false,
  fetchAccountError: false,
  savingAccountError: false,
  errors: null,
  sentData: null,
  path: null
};

function userAccountReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_ACCOUNT:
      return {
        ...state,
        loading: true,
        userAccount: null,
        fetched: false,
        fetchAccountError: false,
        success: false,
        path: action.meta.section
      };

    case types.GET_USER_ACCOUNT_COMPLETED:
      return {
        ...state,
        loading: false,
        fetched: true,
        userAccount: action.payload
      };

    case types.GET_USER_ACCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        fetched: true,
        fetchAccountError: true
      };

    case types.PUT_USER_ACCOUNT:
      return {
        ...state,
        loading: true,
        success: false,
        savingAccountError: false,
        errors: null,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.PUT_USER_ACCOUNT_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PUT_USER_ACCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        savingAccountError: true,
        errors: action.payload.data.message
      };

    case types.PATCH_USER_ACCOUNT:
      return {
        ...state,
        loading: true,
        success: false,
        savingAccountError: false,
        errors: null,
        sentData: action.meta
      };

    case types.PATCH_USER_ACCOUNT_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PATCH_USER_ACCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        savingAccountError: true
      };

    case types.POST_USER_ACCOUNT:
      return {
        ...state,
        loading: true,
        success: false,
        savingAccountError: false,
        errors: null,
        path: action.meta.section,
        sentData: action.meta
      };

    case types.POST_USER_ACCOUNT_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.POST_USER_ACCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        savingAccountError: true
      };

    case types.DELETE_USER_ACCOUNT:
      return {
        ...state,
        loading: true,
        success: false,
        savingAccountError: false,
        errors: null,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.DELETE_USER_ACCOUNT_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.DELETE_USER_ACCOUNT_FAILED:
      return {
        ...state,
        loading: false,
        savingAccountError: true,
        errors: action.payload.data.message
      };

    case types.RESET_USER_ACCOUNT:
      return {
        ...state,
        userAccount: null,
        fetched: false,
        success: false,
        fetchAccountError: false,
        savingAccountError: false,
        errors: null,
        sentData: null,
        path: action.meta.section
      };

    default:
      return state;
  }
}

export default userAccountReducer;
